import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translations: require("./translations/en.json"),
            },
            id: {
                translations: require("./translations/id.json"),
            },
            "zh-CN": {
                translations: require("./translations/zh-CN.json"),
            },
            "zh-TW": {
                translations: require("./translations/zh-TW.json"),
            },
            "tl-PH": {
                translations: require("./translations/tl-PH.json"),
            },
            th: {
                translations: require("./translations/th.json"),
            },
            vi: {
                translations: require("./translations/vi.json"),
            },
            "ms-MY": {
                translations: require("./translations/ms-MY.json"),
            },
            ja: {
                translations: require("./translations/ja.json"),
            },
        },
        // lng: "en", // default is set at redux store
        fallbackLng: "en",
        debug: false,

        detection: {
            order: ["localStorage"],
            caches: ["localStorage"],
        },


        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ","
        },

        react: {
            wait: true
        }
    })
export default i18n;
